import { ListItem, styled } from '@mui/material';


const PREFIX = 'StatusListItem';

export const classes = {
  selected: `${PREFIX}-selected`,
  container: `${PREFIX}-container`,
};

export const StyledListItem = styled(ListItem)(({ theme }) => ({
  [`& .${classes.selected}`]: {
    backgroundColor: theme.palette.grey[100],
  },

  [`& .${classes.container}`]: {
    overflow: 'auto',
    maxHeight: '60vh',
  },
}));